const Main = () => import(/* webpackChunkName: "exoty" */ '@/modules/main/main.vue');
const EmptyRouterView = () => import(/* webpackChunkName: "exoty" */ '@/components/EmptyRouter.vue');

const PromoCodeAdd = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/code/view/add.vue');
const PromoCodeDetail = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/code/view/detail.vue');
const PromoCodeList = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/code/view/index.vue');

const PromoItemAdd = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/item/view/add.vue');
const PromoItemClone = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/item/view/add.vue');
const PromoItemDetail = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/item/view/detail.vue');
const PromoItemEdit = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/item/view/edit.vue');
const PromoItemList = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/item/view/index.vue');
const PromoItemTranslate = () =>
    import(/* webpackChunkName:"promotion" */ '@/modules/promotion/item/view/translate.vue');

const PromoPrototypeAdd = () => import(/* webpackChunkName:"promotion" */ '@/modules/promotion/prototype/view/add.vue');
const PromoPrototypeList = () =>
    import(/* webpackChunkName: "promotion" */ '@/modules/promotion/prototype/view/index.vue');
const PromoPrototypeDetail = () =>
    import(/* webpackChunkName:"promotion" */ '@/modules/promotion/prototype/view/detail.vue');

const PromoBoosterList = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/booster/view/index.vue');
const PromoBoosterAdd = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/booster/view/add.vue');
const PromoBoosterEdit = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/booster/view/edit.vue');
const PromoBoosterDetail = () =>
    import(/* webpackChunkName: "promotion" */ '@/modules/promotion/booster/view/detail.vue');

const PromoPlanList = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/plan/view/index.vue');
const PromoPlanAdd = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/plan/view/add.vue');
const PromoPlanEdit = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/plan/view/edit.vue');
const PromoPlanDetail = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/plan/view/detail.vue');
const PromoPlanTranslate = () =>
    import(/* webpackChunkName: "promotion" */ '@/modules/promotion/plan/view/translate.vue');

const PromoCycleList = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/cycle/view/index.vue');
const PromoCycleDetail = () => import(/* webpackChunkName: "promotion" */ '@/modules/promotion/cycle/view/detail.vue');

export const ROUTE_NAME_PROMOTION = {
    ITEM: {
        INDEX: 'PromotionItemList',
        ADD: 'PromotionItemAdd',
        EDIT: 'PromotionItemEdit',
        CLONE: 'PromotionItemClone',
        DETAIL: 'PromotionItemDetail',
        TRANSLATE: 'PromotionItemTranslate'
    },
    BOOSTER: {
        INDEX: 'PromotionBoosterList',
        ADD: 'PromotionBoosterAdd',
        EDIT: 'PromotionBoosterEdit',
        DETAIL: 'PromotionBoosterDetail',
        TRANSLATE: 'PromotionBoosterTranslate'
    },
    PLAN: {
        INDEX: 'PromotionPlanList',
        ADD: 'PromotionPlanAdd',
        EDIT: 'PromotionPlanEdit',
        DETAIL: 'PromotionPlanDetail',
        TRANSLATE: 'PromotionPlanTranslate'
    },
    PROTOTYPE: {
        INDEX: 'PromotionPrototypeList',
        ADD: 'PromotionPrototypeAdd',
        CLONE: 'PromotionPrototypeClone',
        DETAIL: 'PromotionPrototypeDetail'
    },
    CODE: {
        INDEX: 'PromotionCodeList',
        ADD: 'PromotionCodeAdd',
        DETAIL: 'PromotionCodeDetail'
    },
    CYCLE: {
        INDEX: 'PromotionCycleList',
        DETAIL: 'PromotionCycleDetail'
    }
} as const;

export default [
    {
        path: '/app/:appId/promotion/',
        component: Main,
        meta: { requiresAuth: true },
        children: [
            {
                path: 'item/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PROMOTION.ITEM.INDEX,
                        component: PromoItemList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PROMOTION.ITEM.ADD,
                        component: PromoItemAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id',
                        name: ROUTE_NAME_PROMOTION.ITEM.EDIT,
                        component: PromoItemEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/clone',
                        name: ROUTE_NAME_PROMOTION.ITEM.CLONE,
                        component: PromoItemClone,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PROMOTION.ITEM.DETAIL,
                        component: PromoItemDetail,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/translate',
                        name: ROUTE_NAME_PROMOTION.ITEM.TRANSLATE,
                        component: PromoItemTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'code/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PROMOTION.CODE.INDEX,
                        component: PromoCodeList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PROMOTION.CODE.ADD,
                        component: PromoCodeAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PROMOTION.CODE.DETAIL,
                        component: PromoCodeDetail,
                        meta: { requiresAuth: true }
                    }
                ]
            },
            {
                path: 'prototype/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PROMOTION.PROTOTYPE.INDEX,
                        component: PromoPrototypeList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PROMOTION.PROTOTYPE.ADD,
                        component: PromoPrototypeAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/clone',
                        name: ROUTE_NAME_PROMOTION.PROTOTYPE.CLONE,
                        component: PromoPrototypeAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PROMOTION.PROTOTYPE.DETAIL,
                        component: PromoPrototypeDetail,
                        meta: { requiresAuth: true }
                    }
                ]
            },

            {
                path: 'booster/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PROMOTION.BOOSTER.INDEX,
                        component: PromoBoosterList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PROMOTION.BOOSTER.ADD,
                        component: PromoBoosterAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_PROMOTION.BOOSTER.EDIT,
                        component: PromoBoosterEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PROMOTION.BOOSTER.DETAIL,
                        component: PromoBoosterDetail,
                        meta: { requiresAuth: true }
                    }
                ]
            },

            {
                path: 'plan/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PROMOTION.PLAN.INDEX,
                        component: PromoPlanList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: 'add',
                        name: ROUTE_NAME_PROMOTION.PLAN.ADD,
                        component: PromoPlanAdd,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/edit',
                        name: ROUTE_NAME_PROMOTION.PLAN.EDIT,
                        component: PromoPlanEdit,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PROMOTION.PLAN.DETAIL,
                        component: PromoPlanDetail,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/translate',
                        name: ROUTE_NAME_PROMOTION.PLAN.TRANSLATE,
                        component: PromoPlanTranslate,
                        meta: { requiresAuth: true }
                    }
                ]
            },

            {
                path: 'cycle/',
                component: EmptyRouterView,
                meta: { requiresAuth: true },
                children: [
                    {
                        path: '',
                        name: ROUTE_NAME_PROMOTION.CYCLE.INDEX,
                        component: PromoCycleList,
                        meta: { requiresAuth: true }
                    },
                    {
                        path: ':id/detail',
                        name: ROUTE_NAME_PROMOTION.CYCLE.DETAIL,
                        component: PromoCycleDetail,
                        meta: { requiresAuth: true }
                    }
                ]
            }
        ]
    }
];
